import { ChangePasswordForm } from "../../../components/auth/change-password/ChangePasswordForm.tsx";

export default function ChangePasswordPage() {
  return (
    <div>
      <ChangePasswordForm />
    </div>
  );
}
